/**
 * Author: Fleming Shi
 * Project: DAL (Digital Abstraction Layer)
 * Date: 2025-11-08
 * Revision: 1.0
 * Description: Microsoft Entra ID (Azure AD) authentication configuration
 */

import { Configuration, PopupRequest } from '@azure/msal-browser'

// Validate environment variables
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID
const authority = import.meta.env.VITE_ENTRA_AUTHORITY
// Derive redirectUri from window.location.origin so the app works on any
// domain pointing at the Front Door (dev-dal.ni.comcast.com, *.azurefd.net,
// localhost). Each origin must also be registered in the Entra App.
const redirectUri =
  typeof window !== 'undefined'
    ? window.location.origin
    : import.meta.env.VITE_ENTRA_REDIRECT_URI || 'http://localhost:3000'

if (!clientId || !authority) {
  console.error('CRITICAL: Missing Entra ID configuration!', {
    hasClientId: !!clientId,
    hasAuthority: !!authority,
  })
}

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: clientId || '',
    authority: authority || '',
    redirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
}

// Add scopes here for ID token to be used at Microsoft identity platform endpoints
// Request token for our backend API.
// VITE_ENTRA_SCOPE can override the default api://<client-id>/access_as_user scope.
const scope = import.meta.env.VITE_ENTRA_SCOPE || `api://${clientId}/access_as_user`
export const loginRequest: PopupRequest = {
  scopes: [scope],
}

// Add the endpoints here for Microsoft Graph API services you'd like to use
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
}
